module.exports = __webpack_public_path__ + "img/gift_rice.b61776c7.png";